var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMirrored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.014 3.064h-.11l-1.298 2.574-3.674 6.688-3.674-6.688L1.96 3.064h-.11V16H.046V.644H2.51l4.4 8.272h.11L11.442.644h2.376V16h-1.804V3.064z"
  })));
}

export default __webpack_public_path__ + "4c1b2a268efc81cbab8ca5c4eb04a9a9.svg";
export { SvgMirrored as ReactComponent };